var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"mt-3 pl-4 pr-2"},[_c('b-row',[_c('b-col',{attrs:{"sm":"9"}},[_c('card-first')],1),_c('b-col',{attrs:{"sm":"3"}},[_c('card-waiting')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }